import React, { useState } from "react";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import Translator from "Languages/Utility/Translator";
import { Dialog, DialogActions, DialogContent, Grid } from "@material-ui/core";
import MuiButton from "Components/MuiButton/MuiButton";
import * as Icons from "react-bootstrap-icons";
import { read } from "Helpers/LocalStorage";
import { useTranslation } from "react-i18next";
import { satc_groupLimits } from "Constants/TableColumns";
import AccountService from "Services/http/endpoints/superadmin/AccountsEndpoints";
import StatusHandler from "Helpers/StatusHandler";
import addNumToList from "Helpers/addNumToList";
import showNotify from "Helpers/Notify";
import PayTool from "./PayTool";
import cellEditFactory from "react-bootstrap-table2-editor";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import { useTheme } from "@material-ui/core/styles";
import DialogHead from "Components/DialogHead/DialogHead";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import Input from "Components/Input/Input";

export default function Limits({ row }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [showDialog, setShowDialog] = useState(false);
  const [data, setData] = useState([]);
  const [showPayTool, setShowPayTool] = useState(false);
  const [allNotZero, setAllNotZero] = useState(false);
  const [paymentData, setPaymentData] = useState([]);
  const [dataRequest, setDataRequest] = useState({});
  const [priceCalcLoading, setPriceCalcLoading] = useState(false);
  const [discount, setDiscount] = useState("");

  const onShowDialog = () => {
    setShowDialog(true);
  };

  const onEnter = async () => {
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
        GroupId: row.Id,
      };
      const response = await AccountService.getAccountGroupLimits(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        setData(addNumToList(response.data.Value, 1, 0));
      }
      setTimeout(() => {
        setLoading(false);
      }, 500);
    } catch (e) {
      showNotify({ text: "getDataError", customClass: "error" });
      setShowDialog(false);
    }
  };

  const OnCellChanged = async (oldValue, newValue, _row, column, done) => {
    newValue = +(convertToEnglishNumber(newValue) < 0
      ? -1 * convertToEnglishNumber(newValue)
      : convertToEnglishNumber(newValue));
    const _data = data;
    _data[data.findIndex((obj) => obj.Id == _row.Id)].RequestCount = newValue;
    setData(_data);
    setAllNotZero(
      !_data
        .map((item) => item.RequestCount !== 0)
        .every((item) => item === false)
    );
    done(false);
  };

  const priceCalcfunc = async (e) => {
    e.preventDefault();
    setPriceCalcLoading(true);
    let _req = [];
    data.map((items) => {
      items.RequestCount !== 0 &&
        _req.push({ Id: items.Id, Count: items.RequestCount });
    });
    if (_req.length !== 0) {
      const _data = {
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
        GroupId: row.Id,
        DiscountCode: discount,
        Limits: _req,
      };
      const response = await AccountService.postUpgradeCalculate(_data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        setDataRequest(_data);
        setPaymentData(response.data.Value.Detail);
        setTimeout(() => {
          setPriceCalcLoading(false);
          setShowPayTool(true);
        }, 500);
      } else {
        setTimeout(() => {
          setPriceCalcLoading(false);
        }, 500);
      }
    } else {
      showNotify({ text: t("noDataInIncreaseLimits"), customClass: "error" });
      setPriceCalcLoading(false);
    }
  };

  const backFunc = (e) => {
    setShowPayTool(false);
    e === "submit" && onEnter();
  };

  const onExit = () => {
    setData([]);
    setShowPayTool(false);
    setShowDialog(false);
  };

  return (
    <>
      <ActionFormatter
        title={<Translator id="limits" />}
        icon={<Icons.CardList />}
        onClick={onShowDialog}
        className="primary-button"
      />
      <Dialog
        dir={direction}
        open={showDialog}
        onClose={onExit}
        TransitionProps={{ onEnter: onEnter, onExit: onExit }}
        fullWidth
        maxWidth="lg"
      >
        <DialogHead
          text={<Translator id="limits" />}
          subtext={row.Name}
          icon={<Icons.CardList size={20} />}
        />
        <DialogContent className="p-0 py-2">
          <div className="alert alert-warning px-1 py-2 mt-3">
            <Input
              name="discount"
              type="text"
              setValue={(e) => setDiscount(e.target.value)}
              disabled={priceCalcLoading || loading}
              placeholder={t("discount")}
              value={discount}
              label={<Translator id="discount" />}
            />
          </div>
          <RemoteTable
            data={data}
            loading={loading}
            columns={satc_groupLimits}
            onTableChange={() => {}}
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              autoSelectText: true,
              beforeSaveCell: (oldValue, newValue, row, column, done) =>
                OnCellChanged(oldValue, newValue, row, column, done),
            })}
            showPagination={false}
          />
          {showPayTool && (
            <PayTool
              show={showPayTool}
              GroupId={row.Id}
              GroupName={row.Name}
              data={paymentData}
              dataRequest={dataRequest}
              backFunc={backFunc}
            />
          )}
        </DialogContent>
        <DialogActions>
          <MuiButton
            color="primary"
            title={<Translator id="priceCalculation" />}
            loading={priceCalcLoading}
            disabled={loading || !allNotZero}
            onClick={priceCalcfunc}
          />
          <MuiButton
            onClick={() => setShowDialog(false)}
            title={<Translator id="close" />}
            disabled={priceCalcLoading || loading}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}
